import { Conditional } from 'dg-web-shared/lib/ReactHelpers.tsx';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { Permissions } from '../../../common/state/OperatorLoginData.ts';

export function CreateGuide({ permissions }: { permissions: Permissions }) {
    const hasWhitelist = permissions.whitelistCreate;
    return (
        <Conditional c={permissions.permitsWrite}>
            <Localized
                de={
                    <div>
                        <h1>Erfassen</h1>
                        <h3>
                            Sie können eine neue Bewilligung
                            <Conditional c={hasWhitelist}>
                                <span>{' oder Freigabe'}</span>
                            </Conditional>{' '}
                            erfassen.
                        </h3>
                    </div>
                }
                fr={
                    <div>
                        <h1>Saisir</h1>
                        <h3>
                            Vous pouvez saisir une nouvelle autorisation
                            <Conditional c={hasWhitelist}>
                                <span>{' ou approbation.'}</span>
                            </Conditional>
                        </h3>
                    </div>
                }
                it={
                    <div>
                        <h1>Registrare</h1>
                        <h3>
                            Potete registrare una nuova autorizzazione
                            <Conditional c={hasWhitelist}>
                                <span>{' o approvazione.'}</span>
                            </Conditional>
                        </h3>
                    </div>
                }
                en={
                    <div>
                        <h1>Register</h1>
                        <h3>
                            You can register a new permit
                            <Conditional c={hasWhitelist}>
                                <span>{' or approval.'}</span>
                            </Conditional>
                        </h3>
                    </div>
                }
            />
        </Conditional>
    );
}
